import { zodResolver } from '@hookform/resolvers/zod';
import { reversal as rules } from 'further-ui/validations';
import CalendarDay from 'further-ui/utils/calendar-day';
import React from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { z } from 'zod';

export type ReversalFormValues = z.infer<typeof rules.ReverseActionSchema>;

type Props = {
  children: React.ReactNode;
  actionId: string;
};

const ReversalFormWrapper: React.FC<Props> = ({ children, actionId }) => {
  const formMethods = useForm<ReversalFormValues>({
    shouldFocusError: true,
    resolver: zodResolver(rules.ReverseActionSchema),
    defaultValues: {
      actionId,
      reversalDate: new CalendarDay(new Date()),
    },
  });

  return <FormProvider {...formMethods}>{children}</FormProvider>;
};

export default ReversalFormWrapper;
